import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Image from "react-bootstrap/Image";
import PhoneInput from 'react-phone-input-2';
import Dropdown from 'react-select';
import countries from "../store/data/countries"

import * as actionCreators from "../store/actions"

// IMAGES
import UserOutline from "../images/svgs/UserOutline.svg";
import EmailOutline from "../images/svgs/EmailOutline.svg";
import PhoneOutline from "../images/svgs/PhoneOutline.svg";
import LocationOutline01 from "../images/svgs/LocationOutline01.svg";
import Back from "../images/svgs/Back.svg";

const shippingMethods = [{
  name: "KNET",
  descp: "Pay with your Debit Card",
  price: "FREE",
  currency: "",
  image: "KNET.svg",
  id: 0,
  message: "You will be redirected to KNET’s Payment gateway for the payment process"
}, {
  name: "CREDIT CARD",
  descp: "Pay with your Credit Card",
  price: "5",
  currency: "KWD",
  image: "VISA.svg",
  id: 1,
  message: "You will be redirected to CreditCard’s Payment gateway for the payment process"
}]
const addressTypes = [{
  id: "01",
  name: "House"
}, {
  id: "02",
  name: "Appartment"
}, {
  id: "03",
  name: "Office"
}]
const shipmentSteps = [{
  id: 1,
  name: "Shipping"
}, {
  id: 2,
  name: "Payment"
}, {
  id: 3,
  name: "Done"
}]
class PaymentSelect extends React.Component {
  state = {
    phone: "",
    activeShipment: 1,
    activeStep: 2,
    country: "kw",
    billingSameAsShipment: false
  }
  goBack = () => {
    this.props.history.goBack();
  }

  handleBillingShippment = (event) => {
    this.setState({
      billingSameAsShipment: event.target.checked
    })
  }
  render() {
    const { cartList, currency } = this.props
    document.body.classList.remove('inner-page');
    const translate = this.props.translate;
    return <div className={"addressDiv"}>
      <div className={"addressHeader"}>
        <Image onClick={this.goBack} className={"addressBackBtn"} src={Back} />
        <h4 className={"addressText"}>{"Checkout"}</h4>
        <div className={"stepsHeaderView"}>
          {shipmentSteps.map(step =>
            <div className={"stepInfoOuterView"}>
              <div className={"stepInfo"}>
                <div className={`stepNumber ${step.id === this.state.activeStep && "activeStepNumber"}`}>{step.id}</div>
                <p className={`stepName ${step.id === this.state.activeStep && "activeStep"}`}>{step.name}</p>
              </div>
              {step.id !== 3 &&
                <span className={`horizontalLineStep ${step.id === 1 && "horizontalRight"}`}></span>}
            </div>
          )}
        </div>
      </div>

      <div className={"paymentCart"}>
        <h4 className={"addressSubHeading"}>Order Summary</h4>

        <div className={"bucketListScrollView paymentBucketList"} >
          {cartList && cartList.length === 0 &&
            <p className={"emptyCartText"}>
              {translate['Hey, it feels so light']}
              <p className={"emptyCartText emptyCartSubText"}>
                {translate['There is nothing in your cart']}
              </p>
            </p>}
          {
            cartList && cartList.map(data => {

              return (<div className={"bucketRow"} key={data.id}>
                <Image src={data.media_url} />
                <div className={"qtyBtnDiv"}>
                  <span onClick={() => {
                    if (data.quantity === 1) {
                      return false
                    }
                    this.props.reduceProductQuantity(data.id)
                  }} className={"qtyBtn reduceQty"}>-</span>
                  <input disabled={true} value={data.quantity} className={"prodQty"} />
                  <span onClick={() => { this.props.addProductToMyCart(data.id) }} className={"qtyBtn addQty"}>+</span>
                </div>
                <div className={"bucketInnerDiv"}>
                  <div className={"firstRow"}>
                    <p className="prodName">
                      {data.name}
                    </p>
                    <p className={"priceBox"}>
                      <span>{currency}</span> {data.price}
                    </p>
                  </div>


                </div>


              </div>)
            })
          }
        </div>

      </div>
      <div className={"shipmentOuterDiv"}>
        <h4 className={"addressSubHeading"}>Payment Method</h4>
        {shippingMethods.map(method => <div className={"shipmentMethodRow"} onClick={() => {
          this.setState({
            activeShipment: method.id
          })
        }}>
          <Image className={"paymentModeImage"} src={require(`../images/svgs/PaymentModes/${method.image}`)} />
          <div className={"shipmentType"}>
            <h5 className={"shipmentTypeName"}>{method.name}</h5>
            <p className={"paymentTypeDesc "}>{method.descp}</p>
          </div>
          <span className={`shipmentRadioBtn`}>
            {this.state.activeShipment === method.id && <span className={"activeShipmentRadioBtn"}></span>}
          </span>
        </div>)}

        <p className={"paymentTypeMessage"}>
          {shippingMethods[this.state.activeShipment].message}
        </p>

        {this.state.activeShipment === 1
          && <div className={"billingShipmentQuesDiv"}>
            <p className={"billingShipmentQuesText"}>
              Billing address different from shipment address?
            </p>
            <input checked={this.state.billingSameAsShipment} className={"billingShipmentCheckbox"} type="checkbox" onClick={this.handleBillingShippment} />
          </div>}

      </div>
      {this.state.billingSameAsShipment &&
        <div className={"addressOuterView"}>
          <h4 className={"addressSubHeading"}>Billing Info</h4>
          <div className={"addressAreaField"}>
            <Image className={"locationIcon"} src={UserOutline} />
            <div className={"areaDiv"}>
              <span className={"addressLabel"}>
                {"Full Name"}
              </span>
              <div className={"fullNameDiv"}>
                <input className={"addressInput firstName "} placeholder={"First Name"} />
                <input className={"addressInput lastName"} placeholder={"Last Name"} />
              </div>
            </div>
          </div>

          <div className={"addressAreaField"}>
            <Image className={"locationIcon"} src={EmailOutline} />
            <div className={"areaDiv"}>
              <span className={"addressLabel"}>
                {"Email"}
              </span>
              <input className={"addressInput "} type={"email"} placeholder={"Email"} />

            </div>
          </div>
          <div className={"addressAreaField"}>
            <Image className={"phoneIcon"} src={PhoneOutline} />
            <div className={"areaDiv"}>
              <span className={"addressLabel"}>
                {'PHONE NUMBER'}
              </span>
              <PhoneInput
                defaultCountry={this.state.country}
                onlyCountries={["kw", "sa", "qa", "ae", "bh", "om"]}
                value={this.state.phone}
                onChange={phone => this.setState({ phone })}
                className={"addressInput"}
              />
            </div>
          </div>


          <div className={"addressAreaField"}>
            <Image className={"locationIcon"} src={LocationOutline01} />
            <div className={"areaDiv"}>
              <span className={"addressLabel"}>
                {"Country"}
              </span>
              <select defaultValue={this.state.country} className={"addressInput"} onChange={this.handleCountryChange} >
                <option disabled={true}>{'Select Country'}</option>
                {
                  countries.map(country =>
                    <option
                      key={country.country_code}
                      value={country.country_code}>
                      {country.label}
                    </option>)
                }
              </select>
            </div>
          </div>

          <div className={"addressAreaField"}>
            <Image className={"locationIcon"} src={LocationOutline01} />
            <div className={"areaDiv"}>
              <span className={"addressLabel"}>
                {"AREA"}
              </span>
              <Dropdown
                options={countries[countries.findIndex(ctr => ctr.country_code === this.state.country)].list}
                onChange={this.onAreaChange} value={this.state.area}
                placeholder="Select an Area" />
            </div>
          </div>
          <div className={"addressAreaField"}>
            <Image className={"locationIcon"} src={LocationOutline01} />
            <div className={"areaDiv"}>
              <span className={"addressLabel"}>
                {"Address Type"}
              </span>

              <select
                defaultValue={"Select Adress Type"}
                className={"addressInput"}
                onChange={this.handleAddressTypeChange} >
                <option disabled={true}>{'Select Adress Type'}</option>
                {
                  addressTypes.map(address =>
                    <option
                      key={address.id}
                      value={address.id}>
                      {address.name}
                    </option>)
                }
              </select>
            </div>
          </div>

          <div className={"wrapAddressDiv"}>
            <div className={"addressFieldDiv"}>
              <span className={"addressLabel"}>
                {"BLOCK"}
              </span>
              <input className={"addressInput"} />

            </div>
            <div className={"addressFieldDiv"}>
              <span className={"addressLabel"}>
                {"STREET"}
              </span>
              <input className={"addressInput"} />

            </div>
            <div className={"addressFieldDiv"}>
              <span className={"addressLabel"}>
                {(this.state.addressType === "02" || this.state.addressType === "03") && "BUILDING"}
                {(this.state.addressType === "01") && "HOUSE"}
              </span>
              <input className={"addressInput"} />

            </div>
            <div className={"addressFieldDiv"}>
              <span className={"addressLabel"}>
                {"AVENUE"}
              </span>
              <input className={"addressInput"} />

            </div>

            {(this.state.addressType === "03" || this.state.addressType === "02") &&
              <div className={"addressFieldDiv"}>
                <span className={"addressLabel"}>
                  {"FLOOR"}
                </span>
                <input className={"addressInput"} />

              </div>
            }
            {this.state.addressType === "03" &&
              <div className={"addressFieldDiv"}>
                <span className={"addressLabel"}>
                  {"OFFICE"}
                </span>
                <input className={"addressInput"} />
              </div>
            }
            {this.state.addressType === "02" &&
              <div className={"addressFieldDiv"}>
                <span className={"addressLabel"}>
                  {"Apartment no."}
                </span>
                <input className={"addressInput"} />
              </div>
            }
          </div>
          <div className={"addressInput addressInputFull addressAreaField"}>
            <span className={"addressLabel"}>
              {"ADDITIONAL DIRECTIONS"}
            </span>
            <input className={"addressInput"} />
          </div>
        </div>
      }
      <div className={"proceedToPaymentBottomView"}>
        <div className={"totalPriceView subTotalView"}>
          <h5 className={"shippingFeeText"}>
            {"Cart Subtotal :"}
          </h5>
          <h5 className={"totalPriceAmountSubText"}>
            <span>{this.props.currency} </span>
            {this.props.totalCartAmount}
          </h5>
        </div>
        <div className={"totalPriceView"}>
          <h5 className={"totalPriceText"}>
            {"Total :"}
          </h5>
          <h5 className={"totalPriceAmountText"}>
            <span>{this.props.currency}</span>
            {this.props.totalPaymentWithShipmentFees}
          </h5>
        </div>
        <button className={"checkoutButton"} onClick={() => {
          
           window.dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
              'checkout': {
                'actionField': {
                'step': 2,
                  'option':
                    this.state.activeShipment === "1" ?
                      "Credit Card" :
                      "KNET"
                  },
                'products': this.props.cartList.map(item => {
                    return {
                    'id': item.id,
                    'name': item.name,
                    'quantity': item.quantity,
                    'price': item.price,
                    'unit_price': parseFloat (item.unit_price)
                    }
                  })
                }
              }
           })
          this.props.history.push("/clientwebsite2/paymentend")
        }}>
          {'PAY NOW'}
        </button>
      </div>
    </div>
  }
}
const mapDispatchToProps = dispatch => ({
  myCartList: () => dispatch(actionCreators.myCartList()),
  removeProductFromMyCart: (product_id) => dispatch(actionCreators.removeProductFromMyCart(product_id)),
  addProductToMyCart: (product_id) => dispatch(actionCreators.addProductToMyCart(product_id)),
  reduceProductQuantity: (product_id) => dispatch(actionCreators.reduceProductQuantity(product_id))
});
const mapStateToProps = state => ({

  pathname: state.login.pathname,
  translate: state.websiteLanguage.translations,
  featuredProductsList: state.campaign.featuredProductsList,
  popularProductsList: state.campaign.popularProductsList,
  explore_products: state.campaign.explore_products,
  currency: state.login.currency,
  cartList: state.cart.cartList,
  totalCartAmount: state.cart.totalCartAmount,
  totalPaymentWithShipmentFees: state.cart.totalPaymentWithShipmentFees

});
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentSelect));



// WEBPACK FOOTER //
// ./src/pages/PaymentSelect.js